module.exports = __webpack_public_path__ + "img/arrow-1.7e399f20.svg";